import { render } from "./SinglePage.vue?vue&type=template&id=59a4e7f7"
import script from "./SinglePage.vue?vue&type=script&lang=js"
export * from "./SinglePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maryamdarvishi-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__